import type { Config as DOMPurifyConfig } from 'dompurify';
import { isString } from '@/domain/utils/TypePredicates';
import { sanitiseHTML } from '@/domain/utils/DataSanitiser.service';

// Keep this list of allowed elements and attributes in sync and alphabetical order with app/Library/LibraryServiceProvider.php
const allowedTags = [
	'a',
	'af-field',
	'b',
	'blockquote',
	'br',
	'button',
	'code',
	'del',
	'div',
	'edit-interface-text',
	'em',
	'figcaption',
	'figure',
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'i',
	'iframe',
	'img',
	'li',
	'oembed',
	'ol',
	'p',
	'span',
	'strong',
	'table',
	'tbody',
	'td',
	'tfoot',
	'th',
	'thead',
	'tr',
	'u',
	'ul',
];

const allowedAttributes = [
	'allow',
	'allowfullscreen',
	'allowtransparency',
	'alt',
	'aria-controls',
	'aria-expanded',
	'aria-haspopup',
	'aria-hidden',
	'aria-label',
	'aria-labelledby',
	'autoplay',
	'class',
	'colspan',
	'data-attr',
	'data-content',
	'data-oembed-url',
	'data-redirector',
	'encrypted-media',
	'frameborder',
	'height',
	'href',
	'id',
	'loading',
	'mozallowfullscreen',
	'name',
	'payload',
	'rel',
	'role',
	'rowspan',
	'src',
	'start',
	'style',
	'target',
	'title',
	'type',
	'url',
	'webkitallowfullscreen',
	'width',
];

const defaultConfig: DOMPurifyConfig = {
	ALLOWED_TAGS: allowedTags,
	ALLOWED_ATTR: allowedAttributes,
	SAFE_FOR_TEMPLATES: true,
};

const overrideConfig = (customConfig: DOMPurifyConfig = {}): DOMPurifyConfig => ({
	...defaultConfig,
	...customConfig,
});

const sanitise = <T>(input: T, config?: DOMPurifyConfig): T | string => {
	if (!isString(input)) return input;

	return sanitiseHTML(input, overrideConfig(config));
};

export { sanitise };
